import { useState } from "react";

const FamilyMemberModal = ({ onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: '',
    relationship: 'spouse',
    birth_date: '',
    nif: '',
    gender: '',
    is_dependent: true,
    education_level: '',
    school_name: '',
    special_needs: false,
    notes: ''
  });

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-slate-800 rounded-xl border border-slate-700 w-full max-w-lg" onClick={e => e.stopPropagation()}>
        <div className="p-6 border-b border-slate-700">
          <h3 className="text-xl font-bold text-white">Adicionar Membro do Agregado</h3>
        </div>
        <div className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">Nome Completo *</label>
            <input
              type="text"
              value={formData.name}
              onChange={e => setFormData({...formData, name: e.target.value})}
              className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
              data-testid="family-name-input"
              required
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">Parentesco *</label>
              <select
                value={formData.relationship}
                onChange={e => setFormData({...formData, relationship: e.target.value})}
                className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
              >
                <option value="spouse">Cônjuge</option>
                <option value="partner">Companheiro(a)</option>
                <option value="child">Filho(a)</option>
                <option value="stepchild">Enteado(a)</option>
                <option value="parent">Pai/Mãe</option>
                <option value="sibling">Irmão/Irmã</option>
                <option value="other">Outro</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">Género</label>
              <select
                value={formData.gender}
                onChange={e => setFormData({...formData, gender: e.target.value})}
                className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
              >
                <option value="">Selecionar</option>
                <option value="male">Masculino</option>
                <option value="female">Feminino</option>
                <option value="other">Outro</option>
              </select>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">Data de Nascimento</label>
              <input
                type="date"
                value={formData.birth_date}
                onChange={e => setFormData({...formData, birth_date: e.target.value})}
                className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">NIF</label>
              <input
                type="text"
                value={formData.nif}
                onChange={e => setFormData({...formData, nif: e.target.value})}
                className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
                placeholder="123456789"
              />
            </div>
          </div>
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={formData.is_dependent}
              onChange={e => setFormData({...formData, is_dependent: e.target.checked})}
            />
            <span className="text-sm text-slate-300">É dependente fiscal</span>
          </label>
          {['child', 'stepchild'].includes(formData.relationship) && (
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-slate-300 mb-1">Nível Escolar</label>
                <input
                  type="text"
                  value={formData.education_level}
                  onChange={e => setFormData({...formData, education_level: e.target.value})}
                  className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
                  placeholder="1º Ciclo, Secundário..."
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-300 mb-1">Escola</label>
                <input
                  type="text"
                  value={formData.school_name}
                  onChange={e => setFormData({...formData, school_name: e.target.value})}
                  className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
                />
              </div>
            </div>
          )}
        </div>
        <div className="p-6 border-t border-slate-700 flex justify-end gap-3">
          <button onClick={onClose} className="px-4 py-2 rounded-lg bg-slate-700 text-white hover:bg-slate-600">
            Cancelar
          </button>
          <button
            onClick={() => onSave(formData)}
            disabled={!formData.name}
            className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-500 disabled:opacity-50"
            data-testid="submit-family-btn"
          >
            Adicionar
          </button>
        </div>
      </div>
    </div>
  );
};

export default FamilyMemberModal;
